export default __webpack_public_path__ + "static/media/empty.f05a9d0d.svg";